import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsStudentSchedule } from '@/types/enrollments'

// GET /ajax/athletics/students/{studentAccountId}/schedule (DTA-799 round 5):
// practice rows across every team the student is on whose "share schedule"
// switch is on, each row naming its team. Teams with the switch off are
// simply absent, so there is no 403 to translate here.
export const athleticsStudentSchedule = async (
  studentAccountId: number
): Promise<AthleticsStudentSchedule> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).get(
    '/ajax/athletics/students/' + studentAccountId + '/schedule'
  )
  return Util.Obj.keysToCamel({
    sessions: response.data.sessions ?? []
  }) as AthleticsStudentSchedule
}
